import React, { Component } from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import EmailIcon from '@material-ui/icons/Email';
// import { enqueueSnackbar } from 'notistack';
import TabPanel from '../../components/TabPanel';
import Avatar from '../../components/Avatar';
import ConsultNoteEditModal from '../../components/ConsultNoteEditModal';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
  fetchAdminConsultNotes,
  archiveConsultNote,
  unarchiveConsultNote,
  sendConsultNote,
} from '../../services/api';
import * as authApi from '../../services/api/auth';

const ARCHIVED_BY_ID_TAB = 1;
 
class ProviderAdminSuperAdminConsultNotes extends Component {
  state = {
    isLoading: true,
    consultNotes: [],
    tabPosition: 0,
    noteUnderEdit: {},
    openConsultNoteEditModal: false,
    openSendConsultNoteModal: false,
    currentUser: {},
    pageIndex : 0,
    pageLimit : 20
  };

  async componentDidMount() {
    const { tabPosition } = this.state;
    await this.fetchConsultNotes(tabPosition);
    await this.fetchCurrentUser();
  }

  fetchConsultNotes = async (tabPosition) => {
    const { enqueueSnackbar } = this.props;

    try {
      this.setState({ isLoading: true });

      const consultNotes = await fetchAdminConsultNotes(
        tabPosition === ARCHIVED_BY_ID_TAB, this.state.pageIndex * 20
      );

      this.setState({ consultNotes });
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to fetch notes, please try again.');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  fetchCurrentUser = async () => {
    const currentUser = await authApi.fetchCurrentUser();
    this.setState({ currentUser });
    return currentUser;
  };

  handleTabPositionChange = (event, newTabPosition) => {
    this.setState({ tabPosition: newTabPosition, pageIndex:0 }, ()=>{
      this.fetchConsultNotes(newTabPosition);
    });
  };

  onViewConsultNote = note => {
    this.setState({ noteUnderEdit: note, openConsultNoteViewModal: true });
  };

  onArchiveConsultNote = async note => {
    const { enqueueSnackbar } = this.props;
    const { tabPosition } = this.state;
    try {
      await archiveConsultNote(this.state.currentUser, note);
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to archive note, please try again.');
    } finally {
      this.fetchConsultNotes(tabPosition);
    }
  };

  onUnarchiveConsultNote = async note => {
    const { enqueueSnackbar } = this.props;
    const { tabPosition,currentUser } = this.state;
    try {
      await unarchiveConsultNote(note,currentUser);
      enqueueSnackbar('Successfully unarchived note!');
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to unarchive note, please try again.');
    } finally {
      this.fetchConsultNotes(tabPosition);
    }
  };

  onSendConsultNote = note => {
    this.setState({ noteUnderEdit: note, openSendConsultNoteModal: true });
  };

  sendOffConsultNote = async params => {
    const { enqueueSnackbar } = this.props;
    const { tabPosition } = this.state;

    try {
      await sendConsultNote(params);
      this.onCloseModal();
      enqueueSnackbar('Sent note successfully!');
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to send note, please try again.');
    } finally {
      this.fetchConsultNotes(tabPosition);
    }
  };

  onPageForward = () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    const { enqueueSnackbar } = this.props;
    if (this.state.consultNotes.length < this.state.pageLimit) {
      enqueueSnackbar('You are on the last page');
    }
    else {
      this.setState({pageIndex : this.state.pageIndex + 1},()=>{
        this.fetchConsultNotes(this.state.tabPosition);
      });
    }
  };

  onPageBack = () => {
    const { enqueueSnackbar } = this.props;
    if (this.state.pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    }
    else {
      this.setState({pageIndex : this.state.pageIndex - 1},()=>{
        this.fetchConsultNotes(this.state.tabPosition);
      });
    }
  };

  onCloseModal = () => {
    this.setState({
      noteUnderEdit: {},
      openConsultNoteViewModal: false,
      openSendConsultNoteModal: false,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      isLoading,
      consultNotes,
      tabPosition,
      noteUnderEdit,
      openConsultNoteViewModal,
      openSendConsultNoteModal,
      pageIndex,
      pageLimit
    } = this.state;

    return (
      <Grid container classes={{ container: classes.container }}>
        <Grid item xs={12} lg={6} classes={{ item: classes.header }}>
          <Typography variant="h2" className={classes.headerText}>
            Messages Beta
          </Typography>

          <Typography variant="body1">
            Manage messages "sent to Qwell", those that providers wanted to
            send to providers outside of Qwell or notes they didn't know who to
            send to. You can read the note, discover who it was intended for,
            and send it manually.{' '}
            <strong>Sent notes will be automatically archived.</strong>
          </Typography>
        </Grid>

        <AppBar
          position="static"
          color="default"
          classes={{ root: classes.appBar }}
        >
          <Tabs value={tabPosition} onChange={this.handleTabPositionChange}>
            <Tab label="Open" />
            <Tab label="Archived" />
          </Tabs>
        </AppBar>

        <TabPanel>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
              <Grid item xs={12}>
                <Table> 
                  <TableHead>
                    <TableRow>
                      <TableCell>Patient</TableCell>
                      <TableCell>From (Provider)</TableCell>
                      <TableCell>To (Provider Name / NPI)</TableCell>
                      <TableCell>Received On</TableCell>
                      <TableCell>Sent On</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {consultNotes.sort((m1, m2) => moment(m1.createdAt).isAfter(m2.createdAt) ? -1 : 1).map(note => (
                      <TableRow key={note.id}>
                        <TableCell width="250">{note.patientName}</TableCell>
                        <TableCell width="300">
                          <Grid container alignItems="center">
                            <Grid
                              item
                              xs={12}
                              xl={3}
                            >
                              <Avatar
                                providerId={note.fromProviderId}
                                customStyles={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '4px',
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} xl={9}>
                              {note.fromProviderName}
                            </Grid>
                          </Grid>
                        </TableCell>
                        <TableCell width="250">
                          {note.sendToQwellProviderName} /{' '}
                          {note.sendToQwellProviderNpi}
                        </TableCell>
                        <TableCell width="200">
                          {moment(note.createdAt).format('MM/DD/YYYY hh:mma')}
                        </TableCell>
                        <TableCell width="200">
                          {note.sentAt ? moment(note.sentAt).format('MM/DD/YYYY hh:mma') : 'Unsent'}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => this.onViewConsultNote(note)}
                          >
                            <RemoveRedEyeIcon />
                          </IconButton>

                          <IconButton
                            onClick={() => this.onSendConsultNote(note)}
                          >
                            <EmailIcon />
                          </IconButton>

                          {!note.archived && tabPosition === 0 ? (
                            <IconButton
                              onClick={() => this.onArchiveConsultNote(note)}
                            >
                              <ArchiveIcon />
                            </IconButton>
                          ) : (
                              <IconButton
                                onClick={() => this.onUnarchiveConsultNote(note)}
                              >
                                <UnarchiveIcon />
                              </IconButton>
                            )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <div className={classes.pageTurners}>
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={this.onPageBack}
                  />
                </IconButton>
                <IconButton disabled={consultNotes.length < pageLimit}>
                  <ArrowForwardIosIcon
                    style={{ opacity: consultNotes.length < pageLimit ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={this.onPageForward}
                  />
                </IconButton>
              </div>
              </Grid>
            )}
        </TabPanel>

        <ConsultNoteEditModal
          viewOnly={openConsultNoteViewModal}
          note={noteUnderEdit}
          open={openSendConsultNoteModal || openConsultNoteViewModal}
          save={this.sendOffConsultNote}
          onClose={this.onCloseModal}
        />
      </Grid>
    );
  }
}

const styles = () => ({
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
    paddingBottom: '0.5em',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between'
  },
});

export default withSnackbar(
  withStyles(styles)(ProviderAdminSuperAdminConsultNotes)
);
